import { render, staticRenderFns } from "./DocumentItem.vue?vue&type=template&id=5b210880&scoped=true&"
import script from "./DocumentItem.vue?vue&type=script&lang=js&"
export * from "./DocumentItem.vue?vue&type=script&lang=js&"
import style0 from "./DocumentItem.vue?vue&type=style&index=0&id=5b210880&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b210880",
  null
  
)

export default component.exports